import { render } from "./ConfirmsPassword.vue?vue&type=template&id=66c551f2"
import script from "./ConfirmsPassword.vue?vue&type=script&lang=js"
export * from "./ConfirmsPassword.vue?vue&type=script&lang=js"
script.render = render

export default script